import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { Toaster } from "sonner";
import { loadToken } from "./lib/native";
import { router } from "./router";
import { UpdatePrompt } from "./components/UpdatePrompt";
import { AppBanner } from "./components/stores/AppBanner";
import "./styles.css";
import { LANG } from "@shared/i18n";

document.documentElement.lang = LANG;

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

await loadToken();

// Retire l'écran de démarrage une fois l'application affichée (au moins 0,9 s pour l'animation).
function hideSplash() {
  const el = document.getElementById("splash");
  if (!el) return;
  // Animation complète à l'ouverture de l'app ; ensuite (rechargements de la session) disparition immédiate.
  let seen = false;
  try {
    seen = sessionStorage.getItem("gbc.splash") === "1";
    sessionStorage.setItem("gbc.splash", "1");
  } catch {
    seen = false;
  }
  const wait = seen ? 0 : Math.max(0, 900 - performance.now());
  setTimeout(() => {
    el.classList.add("hide");
    setTimeout(() => el.remove(), 550);
  }, wait);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster position="top-center" richColors closeButton theme="system" />
      <UpdatePrompt />
      <AppBanner />
    </QueryClientProvider>
  </StrictMode>,
);
requestAnimationFrame(() => requestAnimationFrame(hideSplash));
